import {useTranslation} from "react-i18next";
import {ROUTES} from "../../router/config";
import "./ProgressBar.css";

const PROGRESS_CONFIG = {
    [ROUTES.PARENT]: {time: 4, progress: 25},
    [ROUTES.ADDRESS]: {time: 3, progress: 50},
    [ROUTES.STUDENTS]: {time: 2, progress: 72},
    [ROUTES.CONFIRMATION]: {time: 1, progress: 92},
};

const ProgressBar = ({currentRoute}) => {
    const {t} = useTranslation();
    const configKey = Object.keys(PROGRESS_CONFIG).find((key) => currentRoute.includes(key));
    const config = PROGRESS_CONFIG[configKey];

    if (!config) return null;

    return (
        <div className="ProgressBar">
            <p className="ProgressBar-text">
                {t("progress.estimatedTime")} : <strong>{config.time} {t(config.time === 1 ? "progress.minute" : "progress.minutes")}</strong>
            </p>
            <div className="ProgressBar-track">
                <div
                    className="ProgressBar-fill"
                    style={{width: `${config.progress}%`}}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
